<template>
  <div class="order-page">
  
    <!-- 筛选表单组件 -->
    <OrderFilter ref="orderFilter" @filter="handleFilter" @reset="resetFilter" />
    <!-- 现代化订单列表 -->
    <div class="modern-order-container">
      <div class="modern-table-header">
        <div class="header-cell id-col">ID</div>
        <div class="header-cell order-info-col">基本信息</div>
        <div class="header-cell status-col">状态信息</div>
         <div class="header-cell trip-col">行程信息</div>
        <div class="header-cell passenger-col">乘客信息</div> 
       
        <div class="header-cell finance-col">财务详情</div>
        <div class="header-cell ticket-col">出票信息</div>
        
        <div class="header-cell actions-col">操作</div>
      </div>
      
      <div class="modern-table-body">
        <div 
          v-for="order in filteredOrders" 
          :key="order.id" 
          class="modern-row-card">
          
          <!-- ID列 -->
          <div class="modern-cell id-col">
            <div class="id-badge">{{ order.id }}</div>
            <div class="id-badge">{{ order.show_id }}</div>
          </div>
          
          <!-- 订单详情列 -->
          <div class="modern-cell order-info-col">
            <div class="order-main-info">
              <div class="order-number">
                
                 <span class=" copyable" @click="copyToClipboard(order.sn, '订单号')">{{ order.sn || '-' }}</span>
                    <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(order.sn, '订单号')" v-if="order.sn"></i>
                     
              </div>
          
           
              
              <!-- 订单详情 -->
              <div class="order-details-content">
                <div class="details-table">
                  <div class="finance-item finance-item-full ">
                   <span class="label">电话:</span>
                    <span class="value copyable" @click="copyToClipboard(order.tel, '电话')">{{ order.tel || '-' }}</span>
                    <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(order.tel, '电话')" v-if="order.tel"></i>
                  </div>
                  <div class="finance-item finance-item-full ">
                    
                    <span class="label">邮箱:</span>
                    <span class="value copyable" @click="copyToClipboard(order.mail, '邮箱')">{{ order.mail || '-' }}</span>
                    <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(order.mail, '邮箱')" v-if="order.mail"></i>
                  </div>
                  <div class="finance-item finance-item-full ">
                    <span class="label">微信号:</span>
                    <span class="value copyable" @click="copyToClipboard(order.wx_num, '微信号')">{{ order.wx_num || '-' }}</span>
                    <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(order.wx_num, '微信号')" v-if="order.wx_num"></i>
                  
                  </div>
                  <div class="finance-item finance-item-full ">
                     <span class="label">用户ID:</span>
                    <span class="value copyable" @click="copyToClipboard(order.user_id, '用户ID')">{{ order.user_id || '-' }}</span>
                    <i class="el-icon-copy-document copy-icon" @click="copyToClipboard(order.user_id, '用户ID')" v-if="order.user_id"></i>
                  
                  </div>
                 
                 
                </div>
              </div>
            </div>
          </div>

           <!-- 状态信息列 -->
          <div class="modern-cell status-col">
            <div class="status-info">
              <div class="status-item order-status">
                <span class="status-label">订单状态</span>
                <el-tag  effect="dark" :type="getOrderStatusType(order.status)" size="small" class="status-tag">
                  {{ order.strs.status }}
                </el-tag>
              </div>
              <div class="status-item refund-status">
                <span class="status-label">退款状态</span>
                <el-tag effect="dark" :type="getRefundStatusType(order.back_status)" size="small" class="status-tag">
                  {{ order.strs.back_status }}
                </el-tag>
              </div>
              <div class="status-item urgent-status">
                <span  class="status-label">是否加急</span>
                <el-tag effect="dark" :type="order.is_urgent ==1 ? 'danger' : 'info'" size="small" class="status-tag">
                  {{ ['未加急', '加急'][order.is_urgent] }}
                </el-tag>
              </div>

              <div class="order-meta">
                <span class="create-time">
                  <i class="el-icon-time"></i>下单
                  {{ order.created_at }}
                </span>
                
              </div>

              <div class="order-meta">
                <span class="create-time">
                  <i class="el-icon-time"></i>支付
                  {{ order.pay_time }}
                </span>
                
              </div>
              <div class="order-meta">
                <span class="create-time">
                  <i class="el-icon-bank-card"></i>支付
                  {{ order.pay_type }}
                </span>
                
              </div>
              <div class="order-meta">
                <span class="create-time">
                  <i class="el-icon-time"></i>申退
                  {{ order.req_back_time }}
                </span>
                
              </div>
              <div class="order-meta">
                <span class="create-time">
                  <i class="el-icon-time"></i>处退
                  {{ order.ok_back_time }}
                </span>
                
              </div>

            </div>
          </div>
          
          
          
          <!-- 行程信息列 -->
          <div class="modern-cell trip-col">
            <div class="trip-info">
              <div class="trip-header">
                <div class="train-info" v-if="order.fmt">
                  <span class="train-name">{{ order.fmt.bus_tit || '未知车次' }}</span>
                </div>
                
              </div>
              
              <div class="route-info" v-if="order.fmt">
                <div class="departure-info">
                  <span class="station-name clickable" @click="openStationMap(order.fmt.start_tit, order.fmt.start_city, order, 'start')">{{ order.fmt.start_tit || '出发站' }}</span>
                  <span class="station-name">{{ order.fmt.start_city || '-' }}</span>
                  
                  <span class="station-time">{{ order.fmt.start_time || '时间待定' }}</span>
                </div>
                <div class="route-arrow">
                  <i class="el-icon-right"></i>
                </div>
                <div class="arrival-info">
                  <span class="station-name clickable" @click="openStationMap(order.fmt.end_tit, order.fmt.end_city, order, 'end')">{{ order.fmt.end_tit || '到达站' }}</span>
                  <span class="station-name">{{ order.fmt.end_city || '-' }}</span>
                  <span class="station-time">{{ order.fmt.end_time || '时间待定' }}</span>
                </div>
              </div>
              
              <!-- 行程详情 -->
              <div class="trip-details-content">
                <div class="details-table" v-if="order.fmt">
                  
                  
                  
                  <div class="finance-item">
                    <span class="label">候补:</span>
                    <span class="value">{{ order.isAllowed ? '是' : '否' }}</span>
                  </div>
                  <div class="finance-item">
                    <span class="label">出发日期:</span>
                    <span class="value">{{ order.date }}
                      <span class=" tuchu2"> {{ fmt_neady(order.near_day) }}</span>

                    </span>
                  </div>
                  <div class="finance-item">
                    <span class="label">来源:</span>
                    <span class="value">{{ order.source }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 乘客信息列 -->
          <div class="modern-cell passenger-col">
            <div class="passenger-info">
              <div class="passenger-count">
                <i class="el-icon-user"></i>
                <span>{{ order.contacts.length || 0 }}人</span>
              </div>
              <div class="passenger-details" v-if="order.contacts && order.contacts.length > 0">
                <div v-for="(contact, index) in order.contacts" :key="index" class="passenger-item" @click="editContact(contact, order)">
                  <span class="passenger-name">{{ contact.name || '未知' }}  <span class="passenger-info-text">{{ contact.age || '' }} {{ [ '女','男'][contact.sex] || '' }}</span></span>
                 

                   <span class="passenger-jp-name">{{ contact.jp_name || '未翻译' }}</span>
                   <span class="passenger-price">费用:{{ contact.price  }}</span>
                </div>
             
              </div>
            </div>
          </div>
          
          <!-- 财务详情列 -->
          <div class="modern-cell finance-col">
            <div class="finance-info">
              <div class="finance-header">
                <div class="finance-item ">
                   <span class="label">订单金额:</span>
                  <span class="value tuchu">{{ order.amount }} 元</span>
                     
                </div>
                <div class="finance-item ">
                   <span class="label">实付金额:</span>
                    <span class="value">{{ order.cn_pay_money || '-' }} 元</span> 
                </div>
                 
              </div> 
              <div class="finance-header">
                <div class="finance-item ">
                   <span class="label">优惠券:</span>
                  <span class="value">{{ order.coupon_dec }}</span>
                     
                </div>
                <div class="finance-item ">
                    
                </div>
                 
              </div> 
              <div class="finance-header">
                <div class="finance-item ">
                   <span class="label">原单价:</span>
                  <span class="value">{{ order.org_one_price }} 日元</span>
                     
                </div>
                <div class="finance-item ">
                   <!-- <span class="label"></span> -->
                    <span class="value">{{(order.org_one_price / order.exc_rate).toFixed(2) }} 元</span> 
                </div>
                 
              </div> 

              <div class="finance-header">
                <div class="finance-item ">
                   <span class="label">退款金额:</span>
                  <span 
                    :class=" order.refund_money > 0 ? 'tuchu tuchu2 value clickable' : 'value' " 
                    @click="openRefundLogDialog(order.id)"
                    :style="order.refund_money > 0 ? 'cursor: pointer;' : ''">{{ order.refund_money }} 元</span>
                     
                </div>
                <div class="finance-item ">
                    
                </div>
                 
              </div> 

              <div class="finance-header">
                <div class="finance-item ">
                   <span class="label">
                    <div> 购票成本:</div>
                    <div> (巴士公司)</div>
                    </span>
                  <span 
                    :class=" order.ticket_org_amount_cn > 0 ? 'tuchu  value clickable' : 'value' " 
                      @click="openFieldEditDialog(order.id, 'ticket_org_amount_cn', '购票成本', order.ticket_org_amount_cn)"
                   
                    :style="order.ticket_org_amount_cn > 0 ? 'cursor: pointer;' : ''">{{ order.ticket_org_amount_cn }} 元</span>
                     
                </div>
                    <div class="finance-item ">
                   <span class="label">
                    <div>退票手续费:</div> 
                    <div> (巴士公司)</div>
                   </span>
                  <span 
                     :class=" order.ticket_refund_jp_money > 0 ? 'tuchu  value clickable' : 'value' " 
                    @click="openFieldEditDialog(order.id, 'ticket_refund_jp_money', '退票手续费', order.ticket_refund_jp_money)"
                    >{{ order.ticket_refund_jp_money }} 元</span>
                     
                </div>
                 
              </div> 

            </div>
          </div>
          
          <!-- 出票信息列 -->
          <div class="modern-cell ticket-col">
            <div class="finance-info">
              <div class="finance-header">
                <div class="finance-item finance-item-full">
                   <span class="label">巴士公司订单号:</span>
                  <span class="value">{{ order.ticket_sn }} </span>
                     
                </div>
              </div>
              <div class="finance-header">
                <div class="finance-item ">
                   <span class="label">订票成本:</span>
                  <span class="value">{{ order.ticket_org_amount }} 日元</span>
                     
                </div>
                <div class="finance-item ">
                   <span class="label">订票成本:</span>
                  <span class="value">{{ order.ticket_org_amount_cn }} 元</span>
                     
                </div>
              </div>
              <div class="finance-header">
                <div class="finance-item finance-item-full">
                  <span class="label">预留电话:</span>
                  <span class="value">{{ order.ticket_tel }} </span>
                     
                </div>
               
              </div>
             <div class="finance-header">
                <div class="finance-item finance-item-full">
                   <span class="label">お支払い:</span>
                  <span class="value">{{ order.ticket_pay }} </span>
                     
                </div>
                
              </div>
              <div class="finance-header">
                <div class="finance-item finance-item-full">
                   <span class="label">备注:</span>
                  <span class="value">{{ order.ticket_note }} </span>
                     
                </div>
                
              </div>
            </div>
          </div>
          
         
          
          <!-- 操作列 -->
          <div class="modern-cell actions-col">
                   <el-button 
            
              type="success" 
              size="mini" 
              @click="copyInfo(order)"
              icon="el-icon-document-copy">
              复制信息
            </el-button>

            <el-button 
            v-if="order.status == 1   || order.status == 2"
              type="success" 
              size="mini" 
              @click="openSendDialog(order.id)"
              icon="el-icon-s-promotion">
              出票处理
            </el-button>
          
        
            <el-button 
              :type="order.back_status == 1 ? 'danger' : 'info'" 
              size="mini" 
              @click="openUserRefundDialog(order.id)"
              icon="el-icon-user-solid">
              退款
            </el-button>
            
            <el-button 
            v-if="order.status == 0"
              type="success" 
              size="mini" 
              @click="openPayConfirmDialog(order.id)"
              icon="el-icon-check">
              支付确认
            </el-button>
           
            <el-button 
              type="info" 
              size="mini" 
              @click="editJson(order)"
              icon="el-icon-edit">
            修改车次
            </el-button>
            
            <el-button 
              type="warning" 
              size="mini" 
              @click="openOrderStatusDialog(order.id)"
              icon="el-icon-setting">
              修改状态
            </el-button>

            <el-button 
             
              size="mini" 
              v-if="order.status == 1"
              type="success" 

              @click="goBuy(order.source_data)"
              icon="el-icon-setting">
              去购买
            </el-button>

          </div>
        </div>
      </div>
    </div>
    
    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
       
        @current-change="handleCurrentChange"
        :current-page="currentPage"
       
        :page-size="pageSize"
        layout="total,   prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 联系人编辑弹窗组件 -->
     <ContactEditDialog 
       :visible.sync="contactDialogVisible" 
       :contactData="contactForm" 
       @success="handleContactUpdateSuccess" />
       
    <!-- JSON编辑弹窗组件 -->
    <JsonEditDialog 
      :visible.sync="jsonDialogVisible" 
      :jsonData="currentJsonData" 
      :orderId="currentOrderId"
      @success="handleJsonUpdateSuccess" />
      
    <!-- 站点地图弹窗组件 -->
    <StationMapDialog 
      :visible.sync="stationMapVisible" 
      :stationData="currentStationData" />
      
    <!-- 出票弹窗 -->
    <OrderTicketDialog
      :visible.sync="ticketDialogVisible"
      :order-id="currentTicketOrderId"
      @success="handleTicketSuccess"
    />

    <!-- 出票处理弹窗 -->
    <OrderSendDialog
      :visible.sync="showOrderSendDialog"
      :order-id="currentOrderId"
      @success="handleDialogSuccess"
    />

    <!-- 联系人退款弹窗 -->
    <ContactRefundDialog
      :visible.sync="showContactRefundDialog"
      :order-id="currentOrderId"
      @success="handleDialogSuccess"
    />

 

    <!-- 用户退款处理弹窗 -->
    <UserRefundDialog
      :visible.sync="showUserRefundDialog"
      :order-id="currentOrderId"
      @success="handleDialogSuccess"
    />

    <!-- 车次修改弹窗 -->
    <ChangeTrainDialog
      :visible.sync="showChangeTrainDialog"
      :order-id="currentOrderId"
      @success="handleDialogSuccess"
    />

    <!-- 支付确认弹窗 -->
    <PayConfirmDialog
      :visible.sync="showPayConfirmDialog"
      :order-id="currentOrderId"
      @success="handleDialogSuccess"
    />

    <!-- 退款记录弹窗 -->
    <RefundLogDialog
      :visible.sync="showRefundLogDialog"
      :order-id="currentOrderId"
    />

    <!-- 订单状态修改弹窗 -->
    <OrderStatusDialog
      :visible.sync="showOrderStatusDialog"
      :order-id="currentOrderId"
      @success="handleDialogSuccess"
    />

    <!-- 字段编辑弹窗 -->
    <FieldEditDialog
      :visible.sync="showFieldEditDialog"
      :order-id="currentOrderId"
      :field-name="fieldEditData.fieldName"
      :field-label="fieldEditData.fieldLabel"
      :current-value="fieldEditData.currentValue"
      @success="handleJsonUpdateSuccess"
    />
  </div>
</template>

<script>
import axios from 'axios'
import OrderFilter from '../components/OrderFilter.vue'
import ContactEditDialog from '../components/ContactEditDialog.vue'
import JsonEditDialog from '../components/JsonEditDialog.vue'
import StationMapDialog from '../components/StationMapDialog.vue'
import OrderTicketDialog from '../components/OrderTicketDialog.vue'
import OrderSendDialog from '../components/OrderSendDialog.vue'
import ContactRefundDialog from '../components/ContactRefundDialog.vue'
import OrderRefundDialog from '../components/OrderRefundDialog.vue'
import UserRefundDialog from '../components/UserRefundDialog.vue'
import ChangeTrainDialog from '../components/ChangeTrainDialog.vue'
import PayConfirmDialog from '../components/PayConfirmDialog.vue'
import RefundLogDialog from '../components/RefundLogDialog.vue'
import OrderStatusDialog from '../components/OrderStatusDialog.vue'
import FieldEditDialog from '../components/FieldEditDialog.vue'

export default {
  name: 'OrderPage',
  components: {
    OrderFilter,
    ContactEditDialog,
    JsonEditDialog,
    StationMapDialog,
    OrderTicketDialog,
    OrderSendDialog,
    ContactRefundDialog,
    OrderRefundDialog,
    UserRefundDialog,
    ChangeTrainDialog,
    PayConfirmDialog,
    RefundLogDialog,
    OrderStatusDialog,
    FieldEditDialog
  },
  data() {
    return {
      // 筛选表单展开状态
      showFilter: true,
      // 原始订单数据
      orders: [],
      
      // 分页相关
      currentPage: 1,
      pageSize: 20,
      total: 0,
      
      // 联系人编辑相关
      contactDialogVisible: false,
      contactForm: {},
      
      // JSON编辑相关
      jsonDialogVisible: false,
      currentJsonData: {},
      currentOrderId: null,
      
      // 站点地图相关
      stationMapVisible: false,
      currentStationData: {},
      
      // 出票相关
      ticketDialogVisible: false,
      currentTicketOrderId: null,
      
      // 新增组件显示状态
      showOrderSendDialog: false,
      showContactRefundDialog: false,
   
      showUserRefundDialog: false,
      showChangeTrainDialog: false,
      showPayConfirmDialog: false,
      showRefundLogDialog: false,
      showOrderStatusDialog: false,
      showFieldEditDialog: false,
      currentOrderId: null,
      
      // 字段编辑相关
      fieldEditData: {
        fieldName: '',
        fieldLabel: '',
        currentValue: ''
      }
    }
  },
  mounted() {
    this.getOrderList()
  },
  computed: {
    // 直接使用API返回的订单数据
    filteredOrders() {
      return this.orders
    }
  },
  methods: {
    // 获取订单列表
    async getOrderList(params = {}) {
      try {
        // 添加分页参数
        const requestParams = {
          page: this.currentPage,
          page_size: this.pageSize,
          ...params
        }
        
        const response = await axios.get(this.base_url + '/order_server/get_order_list', { params: requestParams })
        if (response.status === 200) {
          this.orders = this.formatOrderData(response.data.data.list)
          // 更新总数
          this.total = response.data.data.total || 0
        } else {
          this.$message.error('获取订单列表失败')
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.$message.error('获取订单列表失败')
      }
    },
    
    // 格式化订单数据
    formatOrderData(list) {
      return  list
    },
    fmt_neady(v){
      if (v== 0) {
        return '今天';
      }
      if (v < 0) {
        return '已出发';
      }
      return `${v}天`
    },
    // 编辑联系人
    editContact(contact, order) {
      this.contactForm = { ...contact, order_id: order.id }
      this.contactDialogVisible = true
    },
    
    // 获取单个订单信息
    async getOrderOne(orderId) {
      try {
        const response = await axios.get(`${this.base_url}/orders/getOrderOne/${orderId}`)
        if (response.status === 200 && response.data.code) {
          return response.data.data
        } else {
          this.$message.error('获取订单信息失败')
          return null
        }
      } catch (error) {
        console.error('获取订单信息失败:', error)
        this.$message.error('获取订单信息失败')
        return null
      }
    },

    // 更新订单列表中的单个订单数据
    updateOrderInList(updatedOrder) {
      const index = this.orders.findIndex(order => order.id === updatedOrder.id)
      if (index !== -1) {
        this.$set(this.orders, index, updatedOrder)
      }
    },

    // 处理联系人更新成功
    async handleContactUpdateSuccess(contactData) {
      // 获取更新后的单个订单信息
      if (contactData && contactData.order_id) {
        const updatedOrder = await this.getOrderOne(contactData.order_id)
        if (updatedOrder) {
          this.updateOrderInList(updatedOrder)
        }
      } else {
        // 如果没有订单ID，则重新获取所有订单列表
        await this.getOrderList()
      }
    },
    
    // 编辑JSON数据
    editJson(order) {
      this.currentOrderId = order.id
      this.currentJsonData = order.source_data || {}
      this.jsonDialogVisible = true
    },
    
    // 处理JSON更新成功
    async handleJsonUpdateSuccess() {
      // 获取更新后的单个订单信息
      if (this.currentOrderId) {
        const updatedOrder = await this.getOrderOne(this.currentOrderId)
        if (updatedOrder) {
          this.updateOrderInList(updatedOrder)
        }
      } else {
        // 如果没有当前订单ID，则重新获取所有订单列表
        await this.getOrderList()
      }
    },
    
    // 处理出票成功
    async handleTicketSuccess() {
      // 获取更新后的单个订单信息
      if (this.currentTicketOrderId) {
        const updatedOrder = await this.getOrderOne(this.currentTicketOrderId)
        if (updatedOrder) {
          this.updateOrderInList(updatedOrder)
        }
      } else {
        // 如果没有当前订单ID，则重新获取所有订单列表
        await this.getOrderList()
      }
      this.$message.success('出票成功')
    },

    // 打开出票处理弹窗
    openSendDialog(orderId) {
      this.currentOrderId = orderId
      this.showOrderSendDialog = true
    },

    // 打开联系人退款弹窗
    openContactRefundDialog(orderId) {
      this.currentOrderId = orderId
      this.showContactRefundDialog = true
    },
 

    // 打开用户退款处理弹窗
    openUserRefundDialog(orderId) {
      this.currentOrderId = orderId
      this.showUserRefundDialog = true
    },
    goBuy(org){
      let obj = JSON.parse(org)
      if (obj.link) {
        window.open('https://www.bushikaku.net'+obj.link)
      } else {
        this.$message.error('没有购买链接')
      }
    },
    // 打开车次修改弹窗
    openChangeTrainDialog(orderId) {
      this.currentOrderId = orderId
      this.showChangeTrainDialog = true
    },

    // 打开支付确认弹窗
    openPayConfirmDialog(orderId) {
      this.currentOrderId = orderId
      this.showPayConfirmDialog = true
    },

    // 处理弹窗成功回调
    async handleDialogSuccess() {
      // 获取更新后的单个订单信息
      if (this.currentOrderId) {
        const updatedOrder = await this.getOrderOne(this.currentOrderId)
        if (updatedOrder) {
          this.updateOrderInList(updatedOrder)
        }
      } else {
        // 如果没有当前订单ID，则重新获取所有订单列表
        await this.getOrderList()
      }
      
      // 关闭所有弹窗
      this.showOrderSendDialog = false
      this.showContactRefundDialog = false
      this.showUserRefundDialog = false
      this.showChangeTrainDialog = false
      this.showPayConfirmDialog = false
      this.showOrderStatusDialog = false
      this.showFieldEditDialog = false
      this.currentOrderId = null
    },
    
    // 打开站点地图
    openStationMap(stationName, cityName, order, type) {
      if (!stationName || stationName === '出发站' || stationName === '到达站') {
        this.$message.warning('暂无站点信息')
        return
      }
      
      if (!order || !order.fmt) {
        this.$message.warning('订单数据不完整')
        return
      }
      
      let stationData = null
      
      if (order.source === 'bushikaku') {
        // bushikaku数据源使用start_obj/end_obj，确保包含source字段
        if (type === 'start') {
          stationData = {
            ...order.fmt.start_obj,
            source: order.source
          }
        } else {
          stationData = {
            ...order.fmt.end_obj,
            source: order.source
          }
        }
      } else {
        // 其他数据源构造参数
        if (type === 'start') {
          stationData = {
            source: order.source,
            key: order.fmt.start_key,
            name: order.fmt.jp_start_tit || stationName
          }
        } else {
          stationData = {
            source: order.source,
            key: order.fmt.end_key,
            name: order.fmt.jp_end_tit || stationName
          }
        }
      }
      
      if (stationData) {
        this.currentStationData = stationData
        this.stationMapVisible = true
      } else {
        this.$message.warning('暂无站点位置信息')
      }
    },
     
     // 格式化日期
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    // 切换筛选器显示状态
    toggleFilter() {
      this.showFilter = !this.showFilter
    },
    
 
    
 
    
   
    
 
    
    // 处理筛选
    async handleFilter(filterParams) {
      try {
        // 筛选时重置到第一页
        this.currentPage = 1
        await this.getOrderList(filterParams)
      } finally {
        // 重置筛选按钮的loading状态
        if (this.$refs.orderFilter) {
          this.$refs.orderFilter.resetLoading()
        }
      }
    },
    
    // 重置筛选
    async resetFilter() {
      try {
        // 重置筛选时重置到第一页
        this.currentPage = 1
        await this.getOrderList()
      } finally {
        // 重置筛选按钮的loading状态
        if (this.$refs.orderFilter) {
          this.$refs.orderFilter.resetLoading()
        }
      }
    },
    
    // 复制订单信息
    copyInfo(order) {
      let info = `
出发日志 ${order.date}
订单号: ${order.sn}
车次:
 ${order.fmt.org_bus_tit}
出发站: 
 ${order.fmt.jp_start_tit} ${order.fmt.start_time}
到达站:
 ${order.fmt.jp_end_tit} ${order.fmt.end_time}
 
联系人:
`
 for (const contact of order.contacts) {
  info += `
 ${contact.name}  ${contact.sex === '1' ? '男' : '女'}   ${contact.age}
  `
 }

 info += `
 原单价 ${order.org_one_price} 日元 x ${order.contacts.length} 人  
 `
      this.copyToClipboard(info, '订单信息')
    },
    
    // 复制到剪贴板
    async copyToClipboard(text, label) {
      if (!text || text === '-') {
        this.$message.warning(`${label}信息为空，无法复制`)
        return
      }
      
      try {
        // 检查是否在iframe中运行
        const isInIframe = window.self !== window.top
        
        // 如果在iframe中，直接使用降级方案
        if (isInIframe) {
          this.fallbackCopyTextToClipboard(text)
        } else if (navigator.clipboard && window.isSecureContext) {
          // 使用现代浏览器的 Clipboard API
          await navigator.clipboard.writeText(text)
        } else {
          // 降级方案：使用传统的 document.execCommand
          this.fallbackCopyTextToClipboard(text)
        }
        this.$message.success(`${label}已复制到剪贴板`)
      } catch (error) {
        console.error('复制失败:', error)
        // 如果所有方法都失败，尝试最后的降级方案
        try {
          this.fallbackCopyTextToClipboard(text)
          this.$message.success(`${label}已复制到剪贴板`)
        } catch (fallbackError) {
          console.error('降级复制也失败:', fallbackError)
          this.$message.error(`复制失败，请手动复制：${text}`)
        }
      }
    },
    
    // 降级复制方案
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      
      try {
        const successful = document.execCommand('copy')
        if (!successful) {
          throw new Error('execCommand copy failed')
        }
      } finally {
        textArea.remove()
      }
    },
    
 
 
    
 
    
    // 获取订单状态标签类型
    getOrderStatusType(status) {
      const typeMap = {
        '0': 'info',
        '1': 'danger',
        '2': 'primary',
        '3': 'success',
        '4': 'info',
        '5': 'info'
      }
      return typeMap[status] || 'info'
    },
    
    // 获取退款状态标签类型
    getRefundStatusType(status) {
      const typeMap = {
        '0': 'info',
        '1': 'danger',
        '3': 'warning',
        '4': 'danger',
        '5': 'danger'
      }
      return typeMap[status] || 'info'
    },
    
    // 查看订单详情
    viewOrder(order) {
      console.log('查看订单:', order)
      // TODO: 实现查看订单详情功能
    },
    
    // 订单支付
    orderPay(order) {
      this.$confirm('确认标记为已支付吗?', '订单支付', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // TODO: 调用支付API
        this.$message.success('订单已标记为已支付')
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    
  
    // 订单发送 - 出票
    orderSend(order) {
      console.log('打开出票弹窗:', order)
      this.currentTicketOrderId = order.id
      this.ticketDialogVisible = true
    },
  
    
  
    // 处理当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.getOrderList()
    },
    
    // 打开退款记录弹窗
    openRefundLogDialog(orderId) {
      if (!orderId) {
        this.$message.warning('订单ID不能为空')
        return
      }
      this.currentOrderId = orderId
      this.showRefundLogDialog = true
    },

    // 打开订单状态修改弹窗
    openOrderStatusDialog(orderId) {
      if (!orderId) {
        this.$message.warning('订单ID不能为空')
        return
      }
      this.currentOrderId = orderId
      this.showOrderStatusDialog = true
    },

    // 打开字段编辑弹窗
    openFieldEditDialog(orderId, fieldName, fieldLabel, currentValue) {
      if (!orderId) {
        this.$message.warning('订单ID不能为空')
        return
      }
      this.currentOrderId = orderId
      this.fieldEditData = {
        fieldName: fieldName,
        fieldLabel: fieldLabel,
        currentValue: currentValue || ''
      }
      this.showFieldEditDialog = true
    }
  }
}</script>

<style lang="scss" scoped>
// 页面主容器
.order-page {
  padding: 15px;
}

// 分页容器
.pagination-container {
  margin-top: 20px;
  padding: 20px 0;
  text-align: center;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

// 筛选卡片
.filter-card {
  margin-bottom: 15px;
  
  .el-card__header {
    padding: 10px 15px;
    font-size: 14px;
  }
  
  .el-card__body {
    padding: 10px 15px;
  }
}

// 筛选表单
.filter-form,
.filter-form-compact {
  margin: 0;
}

.filter-row-compact {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  min-height: 30px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-right: 12px;
  white-space: nowrap;
  flex-shrink: 0;
  width: 70px;
  text-align: right;
  line-height: 1;
}

.filter-items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  flex: 1;
}

// 紧凑表单项
.compact-item {
  margin-bottom: 0;
  margin-right: 10px;
  
  .el-form-item__label {
    padding: 0 6px 0 0;
    font-size: 12px;
    line-height: 26px;
    color: #2c3e50;
  }
  
  .el-form-item__content {
    line-height: 26px;
  }
  
  .el-form-item {
    margin-bottom: 0;
    margin-right: 0;
  }
  
  // 统一输入框样式
  .el-input--mini .el-input__inner,
  .el-select--mini .el-input__inner {
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    padding: 0 8px;
    border-radius: 3px;
  }
  
  .el-date-editor--mini {
    height: 26px;
    line-height: 26px;
    font-size: 12px;
  }
  
  .el-input-number--mini {
    height: 26px;
    line-height: 26px;
    
    .el-input-number__increase,
    .el-input-number__decrease {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
  }
}

.compact-item-inline {
  margin-bottom: 0;
  margin-right: 0;
}

// 订单列表容器
.modern-order-container {
  background: #ffffff;
  border: 1px solid #e8f4fd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

// 表格头部
.modern-table-header {
  display: grid;
  grid-template-columns: 80px 260px 180px 280px 280px 280px 300px 130px;
  background: linear-gradient(135deg, #f8fbff 0%, #e8f4fd 100%);
  color: #2c3e50;
  font-weight: 500;
  font-size: 13px;
  border-bottom: 1px solid #e8f4fd;
  
  .header-cell {
    padding: 12px 8px;
    text-align: center;
    border-right: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    
    &:last-child {
      border-right: none;
    }
  }
}

// 表格主体
.modern-table-body {
  max-height: 75vh;
  overflow-y: auto;
  background: #ffffff;
}

// 表格行
.modern-row-card {
  display: grid;
  grid-template-columns: 80px 260px 180px 280px 280px 280px 300px 130px;
  border-bottom: 1px solid #f0f8ff;
  background: #ffffff;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8fbff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }
  
  &:last-child {
    border-bottom: none;
  }
}

// 表格单元格
.modern-cell {
  padding: 12px 8px;
  border-right: 1px solid #f0f8ff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 80px;
  font-size: 12px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  
  &:last-child {
    border-right: none;
  }
}

// ID列样式
.id-col {
  text-align: center;
  justify-content: center;
}

.id-badge {
  font-weight: 500;
  color: #2c3e50;
  background: linear-gradient(135deg, #e8f4fd 0%, #d4edda 100%);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11px;
  border: 1px solid #b8e6b8;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

// 订单详情列样式
.order-main-info {
  gap: 4px;
  display: flex;
  flex-direction: column;
}

.order-number {
  font-weight: 500;
  color: #2c3e50;
  font-size: 13px;
  margin-bottom: 2px;
  font-family: monospace;
  padding: 4px 8px;
  border-radius: 6px;
  background: linear-gradient(135deg, #fff7e6 0%, #e8f4fd 100%);
  border: 1px solid #ffd700;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
   
}

.order-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}

.create-time {
  color: #4a5568;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 3px;
  
  i {
    color: #0ea5e9;
  }
}

.order-amount {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 2px;
}

.amount-label {
  font-size: 10px;
  color: #4a5568;
  font-weight: 400;
}

.amount-value {
  color: #d00;
  font-weight: 500;
  font-size: 13px;
}

// 乘客信息列样式
.passenger-info {
  gap: 4px;
  display: flex;
  flex-direction: column;
}

.passenger-count {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #2c3e50;
  font-weight: 500;
  font-size: 12px;
  
  i {
    color: #0ea5e9;
    font-size: 12px;
  }
}

.passenger-details {
  color: #4a5568;
  font-size: 11px;
  padding: 6px 8px;
  border-radius: 6px;
}

.passenger-item {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-top: 5px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 6px;
  border: 1px solid #bae6fd;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 6px;
  
  &:hover {
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
    border-color: #0ea5e9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.2);
  }
}

.passenger-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 11px;
}

.passenger-info-text {
  font-size: 10px;
  color: #4a5568;
  margin-left: 5px;
}

.more-passengers {
  font-size: 10px;
  color: #4a5568;
  text-align: center;
  padding: 1px;
}

.seat-type {
  color: #2c3e50;
  font-size: 10px;
  font-weight: 400;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid #bae6fd;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

// 联系方式列样式
.contact-info {
  gap: 4px;
  display: flex;
  flex-direction: column;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #2c3e50;
  font-size: 11px;
  padding: 6px 8px;
  background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
  border-radius: 6px;
  border: 1px solid #bbf7d0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  
  i {
    color: #666;
    font-size: 12px;
    width: 14px;
    text-align: center;
  }
}

// 行程信息列样式
.trip-info {
  gap: 4px;
  display: flex;
  flex-direction: column;
}

.train-info {
  display: flex;
  align-items: center;
  gap: 4px;
}

.train-name {
  color: #2c3e50;
  font-size: 15px;
  font-weight: 500;
  padding: 4px 8px;
  
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.route-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  color: #2c3e50;
  font-weight: 400;
  font-size: 11px;
  background: linear-gradient(135deg, #fff9e6 0%, #f0f9ff 100%);
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #ffd700;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.departure-info,
.arrival-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.station-name {
  font-weight: 700;
  font-size: 11px;
  color: #2c3e50;
}

.station-time {
  font-size: 10px;
  color: #4a5568;
}

.route-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  
  i {
    color: #6366f1;
    font-size: 14px;
  }
}

.travel-date {
  color: #6366f1;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  
  i {
    color: #8b5cf6;
    font-size: 12px;
  }
}

// 财务详情列样式
.finance-info {
  gap: 3px;
  display: flex;
  flex-direction: column;
}

.finance-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 4px;
  border-radius: 2px;
  font-size: 10px;
  flex: 0 0 45%;
  border-bottom: 1px solid #e8f3ff;
  
  &.primary {
    background: linear-gradient(135deg, #f8fbff 0%, #f0f9ff 100%);
    border: 1px solid #e0f2fe;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
  
  .label {
    color: #4a5568;
    font-weight: 400;
    font-size: 10px;
    white-space: nowrap;
  }
  
  .value {
    font-weight: 500;
    font-size: 12px;
    white-space: nowrap;
    margin-left: 5px;
    
    &.paid {
      color: #d00;
    }
    
    &.profit {
      color: #060;
    }
    
    &.discount {
      color: #c60;
    }
    
    &.refund {
      color: #900;
    }
  }
}

.finance-item-full {
  align-items: flex-start;
  flex: 0 0 100%;
  justify-content: flex-start;
  position: relative;
  
  .value {
    font-weight: 500;
    font-size: 10px;
    white-space: wrap;
    
  }
  

}

    .copyable {
      cursor: pointer;
      transition: all 0.2s ease;
      padding: 2px 4px;
      border-radius: 4px;
      
      &:hover {
        background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
        color: #0ea5e9;
        transform: translateY(-1px);
      }
    }
  .copy-icon {
    margin-left: 6px;
    color: #6b7280;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
    
    &:hover {
      color: #0ea5e9;
      transform: scale(1.1);
    }
  }
// 状态信息列样式
.status-info {
  gap: 3px;
  display: flex;
  flex-direction: column;
}

.status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  font-size: 11px;
  background: linear-gradient(135deg, #f8fbff 0%, #f0f9ff 100%);
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #e0f2fe;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.status-label {
  color: #4a5568;
  font-weight: 400;
  min-width: 50px;
  font-size: 10px;
}

.status-tag {
  font-weight: 400;
  padding: 1px 4px;
  border-radius: 2px;
  font-size: 10px;
  min-width: 40px;
  text-align: center;
  height: auto;
  line-height: 1.2;
}

.urgent-badge {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #ea580c;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  border: 1px solid #fb923c;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

// 操作列样式
.actions-col {
 display: block;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  width: 100%;
  
  .el-button {
    padding: 4px 8px;
    font-size: 11px;
    border-radius: 3px;
    font-weight: 400;
    min-width: 50px;
    border: 1px solid #e0f2fe;
    
    &:hover {
      background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
      border-color: #0ea5e9;
      box-shadow: 0 2px 6px rgba(14, 165, 233, 0.2);
    }
    
    i {
      margin-right: 3px;
      font-size: 12px;
    }
    
    &--text {
      background: linear-gradient(135deg, #f8fbff 0%, #f0f9ff 100%);
      color: #2c3e50;
      border-color: #e0f2fe;
      
      &:hover {
        background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
        color: #2c3e50;
        border-color: #0ea5e9;
      }
    }
  }
  
  .el-dropdown {
    width: 100%;
    
    .el-button {
      width: 100%;
      background: linear-gradient(135deg, #f8fbff 0%, #f0f9ff 100%);
      color: #2c3e50;
      border-color: #e0f2fe;
      
      &:hover {
        background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
        color: #2c3e50;
        border-color: #0ea5e9;
      }
    }
  }
}
   
// 展开内容样式
.order-expand-content,
.finance-expand-content,
.trip-expand-content,
.ticket-expand-content,
.order-details-content,
.trip-details-content {
  padding: 12px;
  margin-top: 6px;
  border-radius: 8px;
  background: linear-gradient(135deg, #f8fbff 0%, #f0f9ff 100%);
  border: 1px solid #e0f2fe;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.expand-table,
.details-table {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.expand-row {
  &:last-child {
    border-bottom: none;
  }
  
  .label {
    font-weight: 600;
    color: #2c3e50;
    font-size: 11px;
    text-align: right;
    padding-right: 8px;
  }
  
  .value {
    color: #2c3e50;
    font-size: 11px;
    word-break: break-word;
    overflow-wrap: break-word;
  }
}

// 展开按钮样式
.expand-btn {
  color: #4a5568;
  cursor: pointer;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    color: #2c3e50;
    border: 1px solid #bae6fd;
    box-shadow: 0 2px 6px rgba(14, 165, 233, 0.2);
  }
  
  i {
    font-size: 12px;
  }
}

// 状态样式类
.sp_sts_0 {
  color: #6b7280;
  font-weight: 400;
}

.sp_sts_1 {
  color: #dc2626;
  font-weight: 400;
}

.sp_sts_2 {
  color: #059669;
  font-weight: 400;
}

.sp_sts_3 {
  color: #2563eb;
  font-weight: 400;
}

.sp_sts_4 {
  color: #b91c1c;
  font-weight: 400;
}

.sp_sts_5 {
  color: #7c3aed;
  font-weight: 400;
}

// 联系人列表样式
.contact-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-column: span 3;
  
  .contact-item {
    background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%);
    padding: 6px 8px;
    border-radius: 6px;
    font-size: 10px;
    color: #2c3e50;
    border: 1px solid #bbf7d0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }
}

// 链接样式
.link {
  color: #0ea5e9;
  cursor: pointer;
  text-decoration: none;
  font-size: 10px;
  padding: 3px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    color: #0284c7;
    text-decoration: underline;
    box-shadow: 0 1px 3px rgba(14, 165, 233, 0.2);
  }
}

// 金额样式
.amount {
  font-weight: 400;
  color: #d00;
  
  &.positive {
    color: #060;
  }
  
  &.negative {
    color: #d00;
  }
}

// 特殊按钮样式
.btn-pay,
.btn-refund,
.btn-info,
.btn-warning {
  background: #f5f5f5 !important;
  border-color: #ccc !important;
  color: #333 !important;
}

// 表格头部样式
.trip-header,
.ticket-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}

// 行程信息头部样式
.trip-info {
  .trip-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
    position: relative;
    .train-info {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    .source-badge {
      position: absolute;
      top: -10px;
      right: -40px;
      flex-shrink: 0;
      margin-left: auto;
    }
  }
  
  .station-name.clickable {
    color: #409eff;
    cursor: pointer;
    text-decoration: underline;
    
    &:hover {
      color: #66b1ff;
    }
  }
}

.finance-header {
  display: flex;
  justify-content: space-between;
}

// 状态单选按钮组样式
.status-radio-group {
  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
}

.num-badge {
  font-size: 10px;
  padding: 2px 4px;
  border-radius: 2px;
  background: #f00;
  color: #fff;
}

.tuchu {
  font-weight: bold;
  color: rgb(3, 76, 3);;
  font-size: 18px;
  border: 1px solid rgb(3, 76, 3);
  padding: 2px 4px;
  border-radius: 4px;
}
.tuchu2{
    padding: 2px 4px;
  border-radius: 4px;
    color: red;
     border: 1px solid red;
}

// 操作列样式
.actions-col {
  display: flex;
  flex-direction:column;
  flex-wrap: nowrap;
  align-items:stretch;
  gap: 6px;  
  
  .el-button {
    margin: 0;
    height: 26px;
    line-height: 16px;
    min-width: 80px; 
    font-size: 12px;
     
  }
}

// 响应式调整
@media (max-width: 1400px) {
  .actions-col {
    .el-button {
      font-size: 10px;
      padding: 3px 6px;
      height: 26px;
      
      i {
        font-size: 11px;
      }
    }
  }
}
</style>